import React, { useEffect, useState } from "react";
import ChatMessage from "./ChatMessage";
import { useDispatch, useSelector } from "react-redux";
import { addMessage } from "../utils/ChatSlice";
import { generateRandomMessages, generateRandomNames } from "../utils/Helper";
import { MdSend } from "react-icons/md";

function LiveChat() {
  const [liveMessage, setLiveMessage] = useState();

  const chatMsg = useSelector((store) => store.chat.message);

  const dispatch = useDispatch();
  useEffect(() => {
    const live_data = setInterval(() => {
      dispatch(
        addMessage({
          name: generateRandomNames(),
          message: generateRandomMessages(),
        })
      );
    }, 2000);
    return () => clearInterval(live_data);
  }, []);
  return (
    <div className=" w-full h-[550px] ml-4 mt-2 mr-20 mb-6  bg-gray-100 rounded-lg z-10  ">
      <div className="py-3 px-5 border-b border-gray-400 font-bold">
        Live Chat
      </div>

      <div className="ml-2 w-[98%] h-[75%] flex flex-col-reverse overflow-y-auto  ">
        {chatMsg.map((msg, index) => (
          <ChatMessage key={index} name={msg.name} message={msg.message} />
        ))}
      </div>
      <form
        className="p-4 mt-3 w-full border-t-[0.5px] border-gray-400 text-center"
        onSubmit={(e) => {
          e.preventDefault();
          dispatch(addMessage({ name: "ANURAG", message: liveMessage }));
          setLiveMessage("");
        }}
      >
        <input
          className="p-2 mr-3  w-[90%] border-b-[1.5px] bg-gray-100  border-b-gray-400 focus:outline-none"
          type="text"
          placeholder="Say Something..."
          value={liveMessage}
          onChange={(e) => setLiveMessage(e.target.value)}
        />
        <button>
          <MdSend />
        </button>
      </form>
    </div>
  );
}

export default LiveChat;
